export const ListingSection = ({ title, cols = 1, children, childrenClassName = '' }) => {
  return <div className="flex flex-col justify-stretch pt-12">
    {title ? <h2 className="text-3xl text-center pb-8">{title}</h2> : null}
    <div className={`grid grid-cols-${cols} gap-4 ${childrenClassName}`}>
      {children}
    </div>
  </div>
}